import { Component, EventEmitter, Input, Output } from '@angular/core';

const VALID_FILE_EXTENSTIONS_XLSX = [
  '.xlsx',
  'application/vnd.ms-excel.xlsx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

const VALID_FILE_EXTENSTIONS_PDF = ['.pdf', 'application/pdf'];

@Component({
  selector: 'ui-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent {
  @Output() uploadFileEvent = new EventEmitter<File>();
  @Output() downloadFileEvent = new EventEmitter();
  @Output() closeEvent = new EventEmitter();

  @Input() downloadSampleTemplate: boolean = true;
  @Input() supportedFileType: 'XLSX' | 'PDF' = 'XLSX';

  file: File = new File([''], '', { type: '' });
  fileExtensionError = false;

  onFileSelected(event: Event) {
    const files = (event.target as HTMLInputElement).files;
    if (files?.length) this.file = files[0];
  }

  removeFile() {
    this.file = new File([''], '', { type: '' });
    this.fileExtensionError = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const files = (event.dataTransfer as DataTransfer).files;
    if (files?.length) this.file = files[0];
  }

  onDragover(event: DragEvent) {
    event.stopPropagation();
    event.preventDefault();
  }

  validateFileExtenstion(file: File, extension: 'XLSX' | 'PDF') {
    switch (extension) {
      case 'XLSX':
        if (!VALID_FILE_EXTENSTIONS_XLSX.includes(file.type)) {
          this.fileExtensionError = true;
        } else this.fileExtensionError = false;
        break;
      case 'PDF':
        if (!VALID_FILE_EXTENSTIONS_PDF.includes(file.type)) {
          this.fileExtensionError = true;
        } else this.fileExtensionError = false;
        break;

      default:
        break;
    }
  }

  uploadFile() {
    this.validateFileExtenstion(this.file, this.supportedFileType);
    if (!this.fileExtensionError) {
      this.uploadFileEvent.emit(this.file);
    }
  }

  downloadFile() {
    this.downloadFileEvent.emit();
  }

  close() {
    //Note: used to close modal in parent
    this.closeEvent.emit();
  }
}
